import React,{useState,useEffect} from 'react'
import axios from 'axios'
import { Link as RouterLink} from 'react-router-dom'
import { MdModeEdit,MdKeyboardArrowDown,MdKeyboardArrowUp, MdKeyboardArrowRight } from 'react-icons/md'
import {useAuth} from '../index'
import {
  PaymentElement,
  Elements,
  CardElement,
  useCheckout,
  CheckoutProvider,
  StripeElements,
  useStripe,
  useElements
} from '@stripe/react-stripe-js'
import {
  loadStripe
} from '@stripe/stripe-js'
import { IoReturnDownBackSharp } from 'react-icons/io5'
import { FaCcMastercard } from 'react-icons/fa6'
import { FaCcVisa,FaCcAmex,FaCcPaypal,FaCcApplePay,FaAlipay } from 'react-icons/fa'
import { HiMiniCheck } from 'react-icons/hi2'
const APIURL = process.env.NODE_ENV === 'production' ? `${process.env.REACT_APP_DB_ENV}` : `${process.env.REACT_APP_DB_ENV_TEST}`
const stripeTestPromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLISHABLE_KEY)
const CARD_OPTIONS = {
	iconStyle: "solid",
	style: {
		base: {
			iconColor: "#c4f0ff",
			color: 'white',
			fontWeight: 500,
			fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
			fontSize: "24px",
			fontSmoothing: "antialiased",
			":-webkit-autofill": { color: "#fce883" },
			"::placeholder": { color: "#87bbfd" }
		},
		invalid: {
			iconColor:'red',
			color: 'red'
		}
	}
}
function Payment_Premium_1({userInfo2}){
  return (
    <Elements stripe={stripeTestPromise}>
      <Payment_Premium_2 userInfo3={userInfo2}/>
    </Elements>
  )
}
function Payment_Dev_Premium_1({userInfo2}){
  return (
    <Elements stripe={stripeTestPromise}>
      <Payment_Dev_Premium_2 userInfo3={userInfo2}/>
    </Elements>
  )
}
function Payment_Premium_2(){
  return (
    <>
    <div className='w-auto sm:w-[580px] m-[1em]'>
    <h3 className='mb-1 leading-[1.75em] text-[12px] sm:text-[24px] pt-[1em] font-bold bitter'>1. Create your account</h3>
    <RouterLink className='cursor-default text-[12px] underline flex bitter w-fit hover:font-bold' to='/signup'>Create account<MdKeyboardArrowRight className='ml-[-2px] mt-[4px]'/></RouterLink>
    <h3 className='mb-1 leading-[1.75em] text-[12px] sm:text-[24px] pt-[1em] font-bold bitter'>2. Finish payment</h3>
    <div className='text-[9px] sm:text-[12px] w-auto sm:w-[580px] mb-[4px] leading-[1.2]'>
      After login, click username at top right side of the bar > Select account membership status to finish payment.</div>
    <div className='w-auto sm:w-[580px]'>
    <div className='flex justify-between mt-[8px]'>
      <div>
      {/* <div className='text-[12px]'>Premium membership ($10.00/m)</div> */}
      {/* <div className='text-[12px]'>Premium membership ($1.00/m)</div> */}
      <div className='text-[12px]'>Premium membership ($199.00/m)</div>
      </div>
      {/* <div className='mt-auto text-[12px]'>10.00</div> */}
      <div className='mt-auto text-[12px]'>199.00</div>
    </div>
    <div className='flex justify-between text-[12px]'>
      <div className='text-[8px] mb-[4px] leading-[1.2]'>
      <div>Tax country: United States</div>
      <div>Sales tax 8.25%</div>
      </div>
      {/* <div style={{margin: 'auto 0 0'}} className='text-[10px]'>{(10*.0825).toFixed(2)}</div> */}
      <div style={{margin: 'auto 0 0'}} className='text-[10px]'>{(199*.0825).toFixed(2)}</div>
    </div>
    <hr/>
    <div className='flex justify-between text-[12px]'>
      <div>Total</div>
      {/* <div className='text-md'>US${(10*.0825+10).toFixed(2)}</div> */}
      <div className='text-md'>US${(199*(.0825+1)).toFixed(2)}</div>
    </div>
    </div>
    <br/>
    </div>
    </>
  )
}
function Payment_Dev_Premium_2({userInfo3}){
  return (
    <>
    <div className='w-auto sm:w-[580px] m-[1em]'>
    <h3 className='mb-1 leading-[1.75em] text-[12px] sm:text-[24px] pt-[1em] font-bold bitter'>1. Create your account</h3>
    <RouterLink className='cursor-default text-[12px] underline flex bitter w-fit hover:font-bold' to='/signup'>Create account<MdKeyboardArrowRight className='ml-[-2px] mt-[4px]'/></RouterLink>
    <h3 className='mb-1 leading-[1.75em] text-[12px] sm:text-[24px] pt-[1em] font-bold bitter'>2. Finish payment</h3>
    <div className='text-[9px] sm:text-[12px] mb-[4px] leading-[1.2]'>
      After login, click username at top right side of the bar > Select account membership status to finish payment.</div>
    <div className='w-auto sm:w-[580px]'>
    <div className='flex justify-between mt-[8px]'>
      <div>
      {/* <div className='text-[12px]'>Dev Premium membership ($47.00/m)</div> */}
      {/* <div className='text-[12px]'>Dev Premium membership ($1.00/m)</div> */}
      <div className='text-[12px]'>Dev Premium membership ($399.00/m)</div>
      </div>
      {/* <div className='mt-auto text-[12px]'>47.00</div> */}
      <div className='mt-auto text-[12px]'>399.00</div>
    </div>
    <div className='flex justify-between text-[12px]'>
      <div className='text-[8px] mb-[4px] leading-[1.2]'>
      <div>Tax country: United States</div>
      <div>Sales tax 8.25%</div>
      </div>
      {/* <div style={{margin: 'auto 0 0'}} className='text-[10px]'>{(47*.0825).toFixed(2)}</div> */}
      <div style={{margin: 'auto 0 0'}} className='text-[10px]'>{(399*.0825).toFixed(2)}</div>
    </div>
    <hr/>
    <div className='flex justify-between text-[12px]'>
      <div>Total</div>
      {/* <div className='text-md'>US${(47*.0825+47).toFixed(2)}</div> */}
      <div className='text-md'>US${(399*(.0825+1)).toFixed(2)}</div>
    </div>
    </div>
    <br/>
    </div>
    </>
  )
}
export default function AccountMembershipPage() {
    const [userInfo1, setUserInfo1] = useState(null)
    const [selectedMembership, setSelectedMembership] = useState('')
    const [cancelSubscriptionMsg, setCancelSubscriptionMsg] = useState('')
    const onClick2SelectMembership = (x) => {
        console.log('click membership',x)
        setSelectedMembership(x)
    }
    return(
    <div className='m-auto mt-[.2em] sm:mt-[2em] max-w-[650px]'>
    <h2 className='mb-4 text-lg structure__main__subttl'>Membership Price List</h2>
    <div className='hidden m-auto sm:grid grid-cols-3 max-w-[424px]'>
      <div style={{border:selectedMembership=='free'?'2px solid #404C75':'1px solid black'}} className='cursor-default relative structure__subscribe__item' onClick={()=>onClick2SelectMembership('free')}>
      <h3 className='bitter mt-[8px]'>Free Account</h3>
      <div className='mt-[12px] mb-[4px] text-right'>Free</div>
      · Finance app access<br/>
      <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: <span className='font-bold'>Only 1 item is creatable at income and expense page.</span></div>
      <div className='absolute bottom-[14px]'>
      <button className='hover:bg-[#414c75] hover:text-white mt-[84px] bitter border-[.2px] border-gray-800' style={{background:selectedMembership=='free'?'#414c75':'',color:selectedMembership=='free'?'#fff':'',border:selectedMembership=='free'?'0px':''}} onClick={()=>onClick2SelectMembership('free')}>{selectedMembership=='free'?'Selected plan':'Select plan'}</button>
      </div>
      </div>
      <div className={`cursor-default relative structure__subscribe__item`} style={{border:selectedMembership=='premium'?'2px solid #404C75':'1px solid black'}} onClick={()=>onClick2SelectMembership('premium')}>
      <h3 className='bitter mt-[8px]'>Premium</h3>
      {/* <div className='mt-[12px] mb-[4px] text-right'>US$10.00/m</div> */}
       <div className='mt-[12px] text-right'>US$199.00/m + Tax</div>
      {/* <div className='text-right'>US$1.00/m + Tax</div> */}
      {/* <div className='bitter mb-[4px] text-[7px] text-[#1a36c6] font-bold text-right'>test running(Jun-Aug)</div> */}
      · Finance app access<br/>
      <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: all editable</div>
      <div className='absolute bottom-[14px]'>
      <button className='hover:bg-[#414c75] hover:text-white mt-[84px] bitter border-[.2px] border-gray-800' onClick={()=>onClick2SelectMembership('premium')} style={{background:selectedMembership=='premium'?'#414c75':'',color:selectedMembership=='premium'?'#fff':'',border:selectedMembership=='premium'?'0px':''}}>{selectedMembership=='premium'?'Selected plan':'Select plan'}</button>
      </div>
      </div>
      <div className='cursor-default relative structure__subscribe__item' style={{border:selectedMembership=='dev premium'?'2px solid #404C75':'1px solid black'}} onClick={()=>onClick2SelectMembership('dev premium')}>
      <h3 className='bitter mt-[8px]'>Dev Premium</h3> 
      {/* <div className='mt-[12px] mb-[4px] text-right'>US$47.00/m</div> */}
      <div className='mt-[12px] text-right'>US$399.00/m+Tax</div>
      {/* <div className='text-right'>US$2.00/m + Tax</div> */}
      {/* <div className='bitter mb-[4px] text-[7px] text-[#1a36c6] font-bold text-right'>test running(Jun-Aug)</div> */}
      · Finance app access<br/>
     <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: all editable</div>
      · API unlimit access<br/>
      · Code samples
      <div className='absolute bottom-[14px]'>
      <button className='hover:bg-[#414c75] hover:text-white mt-[84px] bitter border-[.2px] border-gray-800' onClick={()=>setSelectedMembership('dev premium')} style={{background:selectedMembership=='dev premium'?'#414c75':'',color:selectedMembership =='dev premium'?'#fff':'',border:selectedMembership=='dev premium'?'0px':''}}>{selectedMembership=='dev premium'?'Selected plan':'Select plan'}</button>
      </div>
      </div>
    </div>
    <div className='m-auto ml-[1em] block sm:hidden'>
      <div style={{border:selectedMembership=='free'?'2px solid #404C75':'1px solid black', backgroundColor:selectedMembership=='free'?'#F3F4F6':'',paddingRight:selectedMembership=='free'?'7px':'8px'}} className='hover:bg-gray-100 cursor-default text-[10px] m-[2px] pt-[1em] pb-[1em] pl-[8px] w-fit' onClick={()=>onClick2SelectMembership('free')}>
        <div className='flex mb-[8px]'>
          <div className='mr-[12px] w-[100px]'> 
            <h3 className='bitter'>Free Account</h3><div>Free</div>
          </div>
          <div className='w-[220px]'>
          · Finance app access<br/>
          <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: <span className='font-bold'>Only 1 item is creatable at income and expense page.</span></div>
          </div>
        </div>    
        <div className='m-auto w-fit'><button className='w-[120px] h-[23px] hover:bg-[#414c75] hover:text-white bitter border-[.2px] border-gray-800' style={{background:selectedMembership=='free'?'#414c75':'',color:selectedMembership=='free'?'#fff':'',border:selectedMembership=='free'?'0px':''}} onClick={()=>onClick2SelectMembership('free')}>{selectedMembership=='free'?'Selected plan':'Select plan'}</button></div>
      </div>
      <div style={{border:selectedMembership=='premium'?'2px solid #404C75':'1px solid black', backgroundColor:selectedMembership=='premium'?'#F3F4F6':'',paddingRight:selectedMembership=='premium'?'7px':'8px'}} className='w-fit hover:bg-gray-100 cursor-default text-[10px] m-[2px] pt-[1em] pb-[1em] pl-[8px] ' onClick={()=>onClick2SelectMembership('premium')}>
        <div className='flex'>
          <div className='mr-[12px] w-[100px]'> 
            <h3 className='bitter'>Premium</h3><div className='line-through'>US$199.00/m+Tax</div>
            <div>US$199.00/m+Tax</div>
            {/* <div className='bitter mb-[4px] text-[7px] text-[#1a36c6] font-bold'>test running(Jun-Aug)</div> */}
          </div>
          <div className='w-[220px]'>
          · Finance app access<br/>
          <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: all editable</div>
          </div>
        </div>    
        <div className='m-auto w-fit'><button className='w-[120px] h-[23px] hover:bg-[#414c75] hover:text-white bitter border-[.2px] border-gray-800' style={{background:selectedMembership=='premium'?'#414c75':'',color:selectedMembership=='premium'?'#fff':'',border:selectedMembership=='premium'?'0px':''}} onClick={()=>onClick2SelectMembership('premium')}>{selectedMembership=='premium'?'Selected plan':'Select plan'}</button></div>
      </div>
      <div style={{border:selectedMembership=='dev premium'?'2px solid #404C75':'1px solid black', backgroundColor:selectedMembership=='dev premium'?'#F3F4F6':'',paddingRight:selectedMembership=='dev premium'?'7px':'8px'}} className='hover:bg-gray-100 cursor-default text-[10px] m-[2px] pt-[1em] pb-[1em] pl-[8px] w-fit' onClick={()=>onClick2SelectMembership('dev premium')}>
        <div className='flex mb-[8px]'>
          <div className='mr-[12px] w-[100px]'> 
            <h3 className='bitter'>Dev Premium</h3><div className='line-through'>US$399.00/m+Tax</div>
            <div>US$2.00/m+Tax</div>
            <div className='bitter mb-[4px] text-[7px] text-[#1a36c6] font-bold'>test running(Jun-Aug)</div>
          </div>
          <div className='w-[220px]'>
          · Finance app access<br/>
          <div className='ml-[6px] leading-[1.2] text-[7px]'>view: all accessible<br/>edit: all editable</div>
          · API unlimit access<br/>
          · Code samples
        </div>    
        </div>    
        <div className='m-auto w-fit'><button className='w-[120px] h-[23px] hover:bg-[#414c75] hover:text-white bitter border-[.2px] border-gray-800' style={{background:selectedMembership=='dev premium'?'#414c75':'',color:selectedMembership=='dev premium'?'#fff':'',border:selectedMembership=='dev premium'?'0px':''}} onClick={()=>onClick2SelectMembership('dev premium')}>{selectedMembership=='dev premium'?'Selected plan':'Select plan'}</button></div>
      </div>
    </div>
    {selectedMembership=='premium'?
    <><Payment_Premium_1 userInfo2={userInfo1}/></>:''}
    {selectedMembership=='dev premium'?<><Payment_Dev_Premium_1 userInfo2={userInfo1}/></>:''}
    {selectedMembership=='free'?<>
    <div className='w-[580px] m-[1em]'>
    <h3 className='mb-1 text-[12px] sm:text-[24px] pt-[1em] font-bold bitter'>1. Create your account</h3>
    <RouterLink className='cursor-default text-[12px] underline flex bitter w-fit hover:font-bold' to='/signup'>Create account<MdKeyboardArrowRight className='ml-[-2px] mt-[4px]'/></RouterLink>
    </div>
    </>:''}
    <br/>

    </div>
    )
}
